import { MapPin, Clock, Building2 } from "lucide-react";
import { COMPANY } from "@/data";
import { Reveal } from "@/components/Reveal";

const AREAS = [
  { name: "Katowice", note: "Siedziba i główny obszar działania" },
  { name: "Górny Śląsk", note: "Cała aglomeracja i województwo śląskie" },
  { name: "Małopolska", note: "Kraków i okolice – dojazd na zlecenie" },
];

export const Coverage = () => {
  return (
    <section id="obszar" className="relative bg-navy-deep text-white py-24 sm:py-32 overflow-hidden" data-testid="coverage-section">
      <div className="absolute inset-0 grid-texture opacity-50" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <Reveal>
              <span className="text-xs font-semibold tracking-[0.2em] uppercase text-magenta-light">
                Obszar działania
              </span>
            </Reveal>
            <Reveal delay={80}>
              <h2 className="mt-4 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight">
                Lokalny elektryk na Śląsku i w Małopolsce
              </h2>
            </Reveal>
            <Reveal delay={140}>
              <p className="mt-6 text-base sm:text-lg text-zinc-300 leading-relaxed">
                Jako firma z Katowic gwarantujemy szybki dojazd do klientów indywidualnych
                i biznesowych na terenie Górnego Śląska oraz Małopolski. Realizujemy zlecenia
                w domach, mieszkaniach, biurach, obiektach komercyjnych i przemysłowych.
              </p>
            </Reveal>

            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-6">
              <div className="flex items-center gap-3" data-testid="coverage-feature-fast">
                <Clock className="w-6 h-6 text-magenta-light" />
                <span className="text-sm text-zinc-200 font-medium">Szybki dojazd i terminowość</span>
              </div>
              <div className="flex items-center gap-3" data-testid="coverage-feature-obj">
                <Building2 className="w-6 h-6 text-magenta-light" />
                <span className="text-sm text-zinc-200 font-medium">Klienci indywidualni i biznes</span>
              </div>
            </div>
          </div>

          <div className="grid gap-px bg-white/10 border border-white/10">
            {AREAS.map((a, i) => (
              <Reveal key={a.name} delay={i * 100} className="bg-navy">
                <div className="flex items-start gap-4 p-7" data-testid={`coverage-area-${i}`}>
                  <MapPin className="w-6 h-6 text-magenta-light mt-1 shrink-0" />
                  <div>
                    <div className="font-heading font-bold text-xl">{a.name}</div>
                    <div className="text-sm text-zinc-400 mt-1">{a.note}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
